


export const changeState = (propsFieldId, value, state, setState) => {
  setState({...state,
    [propsFieldId]: value,
  })
};
